import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  Typography,
  Chip,
  Box,
  useTheme,
  alpha
} from '@mui/material';
import {
  Favorite,
  Visibility,
  Edit,
  TrendingUp,
  CheckCircle
} from '@mui/icons-material';

const RecentActivityCard = ({ activities = [] }) => {
  const theme = useTheme();

  const getActivityIcon = (type) => {
    switch (type) {
      case 'favorite':
        return <Favorite sx={{ color: theme.palette.error.main }} />;
      case 'view':
        return <Visibility sx={{ color: theme.palette.info.main }} />;
      case 'edit':
        return <Edit sx={{ color: theme.palette.warning.main }} />;
      case 'analysis':
        return <TrendingUp sx={{ color: theme.palette.success.main }} />;
      default:
        return <CheckCircle sx={{ color: theme.palette.primary.main }} />;
    }
  };

  const getActivityColor = (type) => {
    switch (type) {
      case 'favorite':
        return alpha(theme.palette.error.main, 0.1);
      case 'view':
        return alpha(theme.palette.info.main, 0.1);
      case 'edit':
        return alpha(theme.palette.warning.main, 0.1);
      case 'analysis':
        return alpha(theme.palette.success.main, 0.1);
      default:
        return alpha(theme.palette.primary.main, 0.1);
    }
  };

  const defaultActivities = [
    { id: 1, type: 'favorite', description: 'Added property to favorites', property: '123 Main St', time: '2 hours ago' },
    { id: 2, type: 'view', description: 'Viewed property details', property: '456 Oak Ave', time: '5 hours ago' },
    { id: 3, type: 'analysis', description: 'Analyzed investment potential', property: '789 Pine Rd', time: '1 day ago' },
    { id: 4, type: 'edit', description: 'Updated property notes', property: '321 Elm St', time: '2 days ago' },
  ];

  const activityList = activities.length > 0 ? activities : defaultActivities;

  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h6" fontWeight="600">
            Recent Activity
          </Typography>
        }
        subheader="Your latest actions and updates"
      />
      <CardContent sx={{ pt: 0 }}>
        <List sx={{ py: 0 }}>
          {activityList.map((activity, index) => (
            <ListItem
              key={activity.id || index}
              sx={{
                px: 0,
                py: 1.5,
                borderBottom: index < activityList.length - 1 ? `1px solid ${theme.palette.divider}` : 'none',
                '&:hover': {
                  bgcolor: alpha(theme.palette.primary.main, 0.02),
                  borderRadius: 1,
                  px: 1,
                  mx: -1,
                }
              }}
            >
              <ListItemAvatar>
                <Avatar
                  sx={{
                    bgcolor: getActivityColor(activity.type),
                  }}
                >
                  {getActivityIcon(activity.type)}
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Typography variant="body2" fontWeight="500">
                    {activity.description}
                  </Typography>
                }
                secondary={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                    <Typography variant="caption" color="text.secondary">
                      {activity.property}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      •
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {activity.time}
                    </Typography>
                  </Box>
                }
              />
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
};

export default RecentActivityCard;











